/* Core & libraries */
import React, {useState} from "react";
import { useTheme } from "react-jss";
import { FormattedMessage, defineMessages, useIntl } from "react-intl";
import Popover from 'react-bootstrap/Popover';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import { ReactComponent as InfoIconSvg } from '../../resources/images/info-icon-active.svg';

/* Styles */
import styles from "./styles.js"

const messages = defineMessages({
  tooltipTitle: {
    id: "teamDefaultTooltip.title"
  },
  tooltipDescription: {
    id: "teamDefaultTooltip.description"
  }
});

const TeamDefaultTooltip = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const { formatMessage } = useIntl();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const renderInfoRole = () => {
    return(
      <Popover className={classes.infoPopover}>
        <div className={classes.infoPopoverDiv}>
          <div className={classes.infoTitle}>
            <FormattedMessage id="teamDefaultTooltip.title"/>
          </div>
          <div className={classes.infoDescription}>
            <FormattedMessage id="teamDefaultTooltip.description"/>
          </div>
        </div>
      </Popover>
    )
  }

  return (
      <div className={classes.roleText} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onFocus={handleMouseEnter} onBlur={handleMouseLeave}>
        <p><FormattedMessage id="teamDefaultTooltip.label"/></p>
        <OverlayTrigger
         show={showTooltip} 
         placement="top" 
         overlay={renderInfoRole()} 
         trigger={['hover', 'focus']} 
        >
          <InfoIconSvg className={classes.infoIcon} tabIndex={0} role="tooltip" aria-label={`${formatMessage(messages.tooltipTitle)} ${formatMessage(messages.tooltipDescription)}`}/>
        </OverlayTrigger>
      </div>
  )
}

export default TeamDefaultTooltip;
